export interface CompanyAddressFields {
  street?: string | null;
  city?: string | null;
  province?: string | null;
  zip?: string | null;
  country?: string | null;
  full_address?: string | null;
  fullAddress?: string | null;
  address?: string | null;
  latitude?: string | number | null;
  longitude?: string | number | null;
  place_id?: string | null;
  placeId?: string | null;
}

/** Text edits invalidate the previous Place; only a new Places selection supplies coordinates. */
export function editCompanyAddress<T extends CompanyAddressFields>(data: T, field: 'street' | 'city' | 'province' | 'zip' | 'country', value: string): T {
  const next = { ...data, [field]: value, latitude: '', longitude: '', place_id: '', placeId: '' };
  if (field === 'street' && !value.trim()) {
    return { ...next, full_address: '', fullAddress: '', address: '', street: '', city: '', province: '', zip: '', country: '' };
  }
  const parts = [next.street, next.zip, next.city, next.province].map((part) => part?.trim() || '');
  const fullAddress = parts.some(Boolean) ? [...parts, next.country?.trim() || ''].filter(Boolean).join(', ') : '';
  return { ...next, full_address: fullAddress, fullAddress, address: fullAddress };
}
